import { ua } from '../../../../util/user-agent';

export class Controller {

    /** @ngInject */
    constructor(
        $rootScope,
        $uibModal,
		$state,
        AccountConfigModal,
		//AccountRegisterModal,
        Alert,
        LoginRoleSelectModal,
        SamlService,
        SharedEpmFactory,
        AccountsResource
    ) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
		this.$state=$state;
        this.AccountConfigModal = AccountConfigModal;
		//this.AccountRegisterModal=AccountRegisterModal;
        this.Alert = Alert;
        this.LoginRoleSelectModal = LoginRoleSelectModal;
        this.SamlService = SamlService;
        this.SharedEpmFactory = SharedEpmFactory;
        this.AccountsResource = AccountsResource;
    }

    modalOpen() {
        this.$rootScope.loginModal = this.$uibModal.open({component: 'loginModal'});
    }

    $onInit() {
        this.isGoogleUser = this.account.roles.includes('ROLE_GOOGLE_USER');
        this.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');
        this.samlAppLogo = window.env.urls.samlAppLogo;
        this.showExtensionAlert = false;
//this.st.registeringApplications=this.registeringApplications;
console.log(this);
    }

    getSamlLoginUrl(applicationId, accountId, awsrole) {
        const app = this.applications.find(a => a.applicationId === applicationId);
        const tabWindowId = window.open('about:blank', '_blank');

        tabWindowId.document.write(`
            <img
                src="${window.env.urls.samlAppLogo(app.slug)}"
                alt="${app.applicationTypeDisplayName}"
                onload="this.style.display = 'block'"
                style="display: none; margin: 50px auto 0;"
            />
        `);

        tabWindowId.document.write(`
            <p style="text-align: center; color:#40A3DB;">
                <img
                    src="${require('./orca-loader.gif')}"
                    onload="this.style.display = 'initial'"
                    alt="Loading..."
                    style="display: none; vertical-align: middle; margin-right: 5px"
                />
                Loading...
            </p>
        `);

        this.SamlService
            .getSamlLoginUrl
            .get({applicationId, accountId, awsrole})
            .$promise
            .then(data => {
                const expires = new Date(Date.now() + 60 * 1000).toUTCString();
                if (data.url.includes("&noCookie=true")) {
                    data.url = data.url.replace("&noCookie=true", '');
                } else {
                    document.cookie = `sso=${app.applicationId}; path=/; expires=${expires}`; //set on production: secure = true
                }

                if (ua.isIOS()) {
                    window.location.assign(data.url);
                } else {
                    tabWindowId.location.href = data.url;
                    if (data.url.includes("/#/")) {
                        tabWindowId.location.reload();
                    }
                }
            }, error => {
                tabWindowId.document.write(`<p style="text-align: center; color:red">Error: ${error.data}</p>`);
            });
    }

    downloadMysqlConnector(application) {
        this.loading = true;
        this.AccountsResource
            .downloadMysqlConnector(application.applicationId, application.companyUserAccountId)
            .then((data) => {
                var file = new Blob([data], {
                    type: 'application/bat'
                });
                // var file = window.URL.createObjectURL(blob);
                var fileURL = URL.createObjectURL(file);
                var a = document.createElement('a');
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'connect_mysql.bat';
                document.body.appendChild(a);
                a.click();
            }).finally(() => this.loading = false)
    }

    showEditPasswordModal(application) {
        this.$uibModal
            .open({
                component: 'accountPasswordUpdate',
                resolve: {application: () => application, isSmsUser: () => this.isSmsUser}
            }).result
            .then(password => {
                application.password = password;
                this.Alert('success', 'applications.account_password_updated');
            });
    }

    showAccountConfigModal(applicationId, accountId) {
        this.AccountConfigModal(applicationId, accountId);
    }
	registerAccountModal(application) {
		//this.AccountRegisterModal(application);
		this.$uibModal.open({
            component: 'accountRegister',
            resolve: {
                application: () => application
            }
        }).result.then((data) => {
			console.log(data);
			console.log(this);
           this.$state.reload('user.applications');
           this.Alert('success', 'accounts.messages.created');
        }).catch(function(reason) {
    		//console.log("Modal dismissed with reason", reason);
});
	}

    epmLogin(sharedAccount) {
        this.SharedEpmFactory.epmsSSO(sharedAccount);

        const isExtensionInstalled =
            !!document.getElementById("saaspass-extension-info") ||
            !!document.getElementById('extension-is-installed-v2.0.1') ||
            !!document.getElementById('extension-is-installed-v2.1.0');

        if (!isExtensionInstalled) {
            this.showExtensionAlert = true;
            this.showIEText = !(
                ua.isChrome() ||
                ua.isOpera() ||
                ua.isFirefox() ||
                ua.isSafari()
            );
        }
    }

    showAwsConfigModal(applicationId, accountId) {
        this.LoginRoleSelectModal(applicationId, accountId)
            .then(role => this.getSamlLoginUrl(applicationId, accountId, role));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/applications.controller.js